export default __webpack_public_path__ + "static/media/icon-testing-from-scratch.9ef7df40.svg";